<template>
	<div class="header-container d-print-none" >
		<div :class="$vuetify.breakpoint.xs ? 'container-item-xs container-item': 'container-item container-left'">
			<div class="show-search" @click="onShowToggle">
				<ShowSearch width="16" hight="16" />
				<div class="ml-3" v-if="!show_search">Show Search</div>
				<div class="ml-3" v-if="show_search">Hide search</div>
			</div>
			<div class="info-text">
				<span>{{ worklist.name === 'All live jobs' ? 'All Live and Proposed jobs' : worklist.name  }}</span>
				<span v-if="$vuetify.breakpoint.smAndUp && worklist.is_dynamic">, dynamic</span>
				<span v-if="$vuetify.breakpoint.smAndUp && worklist.is_owned">, your worklist</span>
				<span v-if="$vuetify.breakpoint.smAndUp && !worklist.is_owned && !worklist.owner.is_admin">, {{ worklist.owner.name }}</span>
				<span v-if="$vuetify.breakpoint.smAndUp && !worklist.is_owned && worklist.owner.is_admin">, JobBag</span>
			</div>
			<v-menu offset-y nudge-left="164" >
				<template v-slot:activator="{ on, attrs }">
					<v-btn fab class="worklist-menu" v-bind="attrs" v-on="on">
						<MenuHoriz class="menu-horiz" />
					</v-btn>
				</template>
				<div v-for="item in menulists_filter"
					:key="item.key"
					@click="onClickMenuItem(item.key)" 
					class="d-print-none" >
					<div :class="`menu-item ${item.usable? 'menu-able': 'menu-disable'}`" >
						<component 
							:is="item.icon"
							:color="item.color" 
							class="menu-icon" 
						/>
						{{ item.title }}
					</div>
				</div>
				<v-divider class="menu-divider d-print-none"></v-divider>
				<div 
					:class="`d-print-none menu-delete ${this.worklist.is_owned ? 'menu-delete-able': 'menu-delete-disable'}`" 
					@click="onDelete()" 
					@mouseover="isHover = true"
					@mouseout="isHover = false">
					<Delete width="15" height="15" class="mr-5" 
						:color="this.worklist.is_owned ? '#192A3E': '#82899B'"
						:selected="isHover && this.worklist.is_owned " 
						:selected_color="'#F45252'"/>
					<div>Delete</div>
				</div>
			</v-menu>
			<div v-if="isSaveAsBtn && $vuetify.breakpoint.smAndUp" class="save-as-btn" @click="$emit('save')">{{ $vuetify.breakpoint.xs ? 'Save': 'Save changes?'}}</div>
		</div>
		<div v-if="$vuetify.breakpoint.smAndUp" class="container-item container-right">
			<div v-if="worklist.acl">
				<div v-if="acllist.length === 1 && acllist[0].usid === 0" class="share-user" >
					<div class="share-user-all" > All Users</div>
				</div>
				<div v-else class="share-user">
					<div v-for="acl in acllist.slice(0, 5)" :key="acl.usid">
						<v-user-avatar
							v-if="acl.usid > 0"
							:size="`36px`"
							:code="acl.name"
							:image="'/api/addressbook/' + acl.adbid + '/image.png'"
						/>
					</div>
					<v-menu offset-y  nudge-bottom="5" open-on-hover v-if="acllist.length > 5">
						<template v-slot:activator="{ on, attrs }">
							<div class="share-user-text" v-bind="attrs" v-on="on">...and more</div>
						</template>
						<v-list v-for="item in acllist.slice(5)"
							:key="item.id" >
							<v-user-avatar
								:size="`20px`"
								:code="item.name"
								:image="item.adbid ? `/api/addressbook/${item.adbid}/image.png`: ''"
								class="text-caption text-decoration-none "
							/>
							{{ item.name }}
						</v-list>
					</v-menu>          
				</div>
			</div>
			<div :class="`share ${worklist.is_owned ? 'share-able': 'share-disable'}`" @click="onShare">
				<Share class="share-icon" :color="worklist.is_owned ? 'rgba(25, 42, 62, 0.7)': 'rgba(25, 42, 62, 0.3)'"/>
				<div>Share</div>
			</div>	
		</div>
		<ShareDialog
			:worklist="worklist"
			ref="share_dialog"
			@changed_share="onChangedShared"
		/>
	</div>
</template>

<script>
import ShowSearch from '@/components/icons/show_search';
import Share from '@/components/icons/share';
import MenuHoriz from '@/components/icons/more-horiz';
import BorderAll from '@/components/icons/border_all';
import GroupBy from '@/components/icons/group_by';
import Rename from '@/components/icons/rename';
import Copy from '@/components/icons/copy';
import Export from '@/components/icons/export';
import Printer from '@/components/icons/printer';
import Delete from '@/components/icons/delete_outline';

import ShareDialog from '@/components/worklist/share_worklist_dialog';

const SHOW_COLOR = '#192A3E';
const UNSHOW_COLOR = '#82899B';

const menulists = [
	{
		key: 'search',
		title: 'Show Search',
		icon: ShowSearch,
		color: SHOW_COLOR,
		usable: true,
	},
	{
		key: 'columns',
		title: 'Show/hide Columns',
		icon: BorderAll,
		color: SHOW_COLOR,
		usable: true,
	},
	// {
	// 	title: 'Group by',
	// 	icon: GroupBy,
	// 	available: false,
	// },
	{
		key: 'share',
		title: 'Share',
		icon: Share,
		color: SHOW_COLOR,
		usable: true,
	},
	{
		key: 'rename',
		title: 'Rename',
		icon: Rename,
		color: SHOW_COLOR,
		usable: true,
	},
	{
		key: 'save',
		title: 'Save as Worklist',
		icon: Copy,
		color: SHOW_COLOR,
		usable: true,
	},
	// {
	// 	key: 'export',
	// 	title: 'Export data',
	// 	icon: Export,
	// 	color: UNSHOW_COLOR,
	// 	usable: false,
	// },
	{
		key: 'print',
		title: 'Print',
		icon: Printer,
		color: SHOW_COLOR,
		usable: true,
	}
]

export default {
	name: 'worklistHeader',
	components: {
		ShowSearch,
		BorderAll,
		Share,
		MenuHoriz,
		GroupBy,
		Rename,
		Copy,
		Export,
		Printer,
		Delete,
		ShareDialog,
	},
	props: {
		worklist: {
			type: Object,
			default: null,
		},
		show_search: {
			type: Boolean,
			default: true,
		},
		isSaveAsBtn: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			acllist: [],
			menulists: menulists,
			isHover: false,
		}
	},
	mounted() {
		this.copy_acl(this.worklist.acl)
	},
	computed: {
		menulists_filter () {
			const arr = [];
			menulists.forEach(menu => {
				if (menu.key === 'rename' || menu.key === 'share') {
					menu['color'] = this.worklist.is_owned ? SHOW_COLOR: UNSHOW_COLOR;
					menu['usable'] = this.worklist.is_owned ? true : false;
				}

				arr.push(menu);
			});
			return arr;
		}
	},
	methods: {
		copy_acl(new_acl) {
			this.acllist = []

			if (new_acl) {
				new_acl.forEach((acl) => {
					this.acllist.push({
						usid: acl.usid,
						adbid: acl.adbid,
						name: acl.name,
						imgerror: false,
					})
				})
			}
		},
		onShowToggle() {
			// this.show_search = !this.show_search
			this.$emit('show-search')
		},
		onShare() {
			if (this.worklist.is_owned) {
				this.$refs.share_dialog.open(this.worklist.acl)
			} 
		},
		onChangedShared(acl) {
			// we just update our data
			this.worklist.acl = acl;
		},
		onShowRename() {
			if (this.worklist.is_owned) {
				this.$emit('show-rename');
			}
		},
		onPrint() {
			this.$emit('print');
			// window.print();
		}, 
		onDelete() {
			if (this.worklist.is_owned) {
				this.$emit('show-delete');
			}
		},
		onClickMenuItem(key) {
			switch (key) {
			case 'search':
				this.onShowToggle();
				break;
			case 'columns':
				this.$emit('show-cols-filter');
				break;
			case 'share':
				this.onShare();
				break;
			case 'rename':
				this.onShowRename();
				break;
			case 'save':
				this.$emit('save-as');
				break;
			case 'print':
				this.onPrint();
				break;
			case 'export':
				break;
					
			default:
				break;
			}
		}
	},
	watch: {
		'worklist.acl': function (new_acl) {
			this.copy_acl(new_acl)
		},
	},
}
</script>
<style lang="scss" scoped>
.header-container {
  padding: 0 22px;
  width: 100%;
  height: 68px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
}
.container-item {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.container-item-xs {
	width: 100%;
}
.container-left {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center; 
}
.show-search {
	padding: 0 12px;
	width: 139px;
	height: 36px;
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	background: #fafafa;
	border-radius: 4px;
	box-shadow: 1px 4px 5px rgba(0, 0, 0, 0.4);

	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 18px;
	letter-spacing: 0.16px;
	color: rgba(25, 42, 62, 0.7);

	&:hover {
		cursor: pointer;
	}
}
.info-text {
	padding: 0 19px;
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 24px;
	color: rgba(25, 42, 62, 0.5);
	:first-child {
		color: #192a3e;
	}
}
.worklist-menu {
	width: 36px;
	height: 36px;
	background: #eaeaea;
}
.menu-horiz {
	width: 18px;
	height: 18px;
	color: #eaeaea;
}
.container-right {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
  .share-user {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
    div {
      padding: 0 4px;
    }
  }
  .share-user-all {
    border-radius: 8px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: rgba(25, 42, 62, 0.7);
    margin-top: 10px;
    margin-right: 4px;

  }
  .share {
    margin-left: 4px;
    padding: 0 14px 0 10px;
		display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
		width: 95px;
    height: 30px;
    background: #fafafa;
    border-radius: 4px;
		box-shadow: 1px 4px 5px rgba(0, 0, 0, 0.4);

		font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    // color: rgba(25, 42, 62, 0.7);

		// &:hover {
		// 	cursor: pointer;
		// }
  }
	.share-able {
		color: rgba(25, 42, 62, 0.7);
			&:hover {
			cursor: pointer;
		}
	}
	.share-disable {
		color: rgba(25, 42, 62, 0.3);
	}
	
  .share-icon {
    width: 18px;
    height: 20px;
  }

  .share-user-text {
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: rgba(25, 42, 62, 0.7);
    margin-top: 10px;
    margin-right: 4px;
  }
}
.menu-icon {
  width: 15px;
  height: 15px;
  color: #DADADA;
  margin-right: 20px;
}
.menu-item {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 16px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  background: #FAFAFA;
}
.menu-able {
  color: #192A3E;
	&:hover {
		background: #EAEAEA;
		cursor: pointer;
	}
}
.menu-disable {
	color: #82899B;
}
.menu-divider {
  margin: 0 6px;
	border-color: #C4C4C4;
}
.menu-delete {
	display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
 	padding: 10px 16px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 15px;
  background: #FAFAFA;
}
.menu-delete-able {
	color: #192A3E;
  &:hover {
    color: #F45252;
    font-weight: 500;
    cursor: pointer;
  }
}
.menu-delete-disable {
  color: #82899B;
}
.save-as-btn {
	border: 1px solid #00AAFD;
	border-radius: 4px;
	color: #00AAFD;
	padding: 0 12px;
	margin: 0 16px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
	font-size: 16px;
	&:hover {
		cursor: pointer;
	}	
}
.theme--light.v-sheet {
  color: red;
  padding: 4px 8px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: rgba(25, 42, 62, 0.7);
}
.v-menu__content {	
	background: #FAFAFA;
}
</style>
